import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DocumentTypeService {


    constructor(private http: HttpClient) {

    }
    /**
     * Esse método recebe um valor para busca de um modelo predefinido de documentTypes
     * @param value - O valor pode ser id ou nome do modelo predefinido de documentTypes
     * @returns O registro relativo ao valor passado
     */
    getModelDocTypes(value: string){
        return this.http.get(`${environment.baseUrl}/documentType/models?name=${value}`) || '';
    }

    /**
     * Busca o mapa de thresholds de classificação por classe (ex: {"contabil-nfse": 0.85, ...})
     */
    getThresholds(){
        return this.http.get(`${environment.baseUrl}/documentType/threshold`);
    }

    /**
     * Atualiza os thresholds de classificação por classe
     * @param thresholds - Lista de objetos { class, threshold }
     */
    updateThresholds(thresholds: { class: string, threshold: number }[]){
        return this.http.put(`${environment.baseUrl}/documentType/updateCacheThreshold`, thresholds);
    }

}